module.exports = " <div class=top :class=transparent v-if=menu.length> <div :class=logo @click=goToHome></div> <navigation-menu></navigation-menu> <sidebar></sidebar> <disclaimer v-if=showDisclaimer></disclaimer> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/app/navigation/Navigation.vue
// module id = 161
// module chunks = 0